export default __webpack_public_path__ + "static/media/product-1.941edd78.jpg";